module.exports = IcbuIM['ReactDOM16'];